<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">회원관리</span>
            <span class="txt">
                센터에 등록한 회원님을 검색하실 수 있으며, 회원님의 성함을 눌러 이용권 등록 및 마일리지 등록 등 회원님의
                다양한 설정을 진행하실 수 있습니다.
            </span>
        </div>
        <div class="com-search-content">
            <!--            <div class='line'>-->
            <!--                <div class='com-calendar-wrap'>-->
            <!--                    <single-calendar :start-date='startDate' @update='startDateUpdate'></single-calendar>-->
            <!--                    <span class='dash'>~</span>-->
            <!--                    <single-calendar :end-date='endDate' @update='endDateUpdate'></single-calendar>-->
            <!--                </div>-->
            <!--                <select-form-->
            <!--                    :select-data="['선택', ...periodTypeList]"-->
            <!--                    :select-value="['', ...periodTypeValueList]"-->
            <!--                    :selected-value='searchPeriod'-->
            <!--                    @update:set='(val) => (searchPeriod = val)'-->
            <!--                ></select-form>-->
            <!--                <div class='com-search-input'>-->
            <!--                    <input-->
            <!--                        v-model='searchStr'-->
            <!--                        placeholder="회원명, 연락처('-'제외)"-->
            <!--                        type='text'-->
            <!--                        v-on:keyup.enter='onEventSearch'-->
            <!--                    />-->
            <!--                    <button class='search-btn' @click='onEventSearch'>검색</button>-->
            <!--                </div>-->
            <!--            </div>-->
            <div class="line">
                <select-form
                    v-if="centerChainList !== undefined && centerChainList.length > 0"
                    :select-data="['선택', ...chainCenterType]"
                    :select-value="['', ...chainCenterTypeValue]"
                    @update:set="(val) => changeCenterId(val)"
                />
                <select-form
                    :select-data="['성별', '남성', '여성']"
                    :select-value="['', 'M', 'W']"
                    :selected-value="sex"
                    @update:set="(val) => changeSex(val)"
                />
                <select-check-form
                    :callback-change-check="(val) => changeSearchTicketTypes(val)"
                    :select-data="['전체', '개인', '듀엣', '그룹', '쿠폰', 'OT', '회원권', '운동복']"
                    :select-value="['all', 'P', 'D', 'G', 'C', 'O', 'T', 'S']"
                    :selected-value="searchTicketTypes"
                    title="이용권구분"
                />
                <select-form
                    :select-data="['이용권 유효여부', '유효', '만료']"
                    :select-value="['', 'V', 'E']"
                    :selected-value="searchTicketStatus"
                    @update:set="(val) => changeSearchTicketStatus(val)"
                />
                <select-check-form
                    :callback-change-check="(val) => changeSearchTeamIds(val)"
                    :select-data="['전체', ...memberGroupList]"
                    :select-value="['all', ...memberGroupValueList]"
                    :selected-value="searchTeamIds"
                    title="회원그룹"
                />
                <select-form
                    :select-data="['회원유효여부', '유효회원', '종료회원', '잠재회원', '홀딩회원']"
                    :select-value="['', 'V', 'E', '-', 'H']"
                    :selected-value="searchStatus"
                    @update:set="(val) => changeSearchStatus(val)"
                />

                <button class="com-search-reset" @click="resetSearchParams"></button>
                <div class="com-search-input">
                    <input
                        v-model="searchStr"
                        placeholder="회원명, 연락처('-'제외)"
                        type="text"
                        v-on:keyup.enter="onEventSearch"
                    />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>

            <div class='line'>
                <label>미방문일수</label>

                <div class='input-group'>
                    <input
                        class='form-control'
                        type="text"
                        v-model="inactiveDays"
                        placeholder="전체"
                        maxlength='3'
                        v-on:keyup.enter="fetchCustomerListPage1"
                    />

                    <div class='input-group-append'>
                        <span class='input-group-text'>일 이상</span>
                    </div>
                </div>

                <button class="btn btn-secondary" @click="fetchCustomerListPage1">조회</button>
            </div>
        </div>
        <p class="sub-title">회원목록</p>
        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="left-box flex">
                    <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
                    <button class="com-btn" @click="changeCheckedUserGroup">회원 그룹 설정</button>
                    <select-check-form
                        :callback-change-check="(val) => changeSelectGroup(val)"
                        :select-data="['전체', ...memberGroupList]"
                        :select-value="['all', ...memberGroupValueList]"
                        :selected-value="selectGroup"
                        title="회원그룹"
                    />
                </div>
                <div class="right-box">
                    <span class="txt">
                        총
                        <span class="blue">{{ totalItems }}</span>
                        건
                    </span>
                    &nbsp;&nbsp;&nbsp;
                    <a class="com-btn red" href="#" @click="deleteManyCustomers">삭제</a>
                    <router-link class="com-btn blue" to="/madmin/member/edit">등록</router-link>
                </div>
            </div>
            <div style='position: relative; margin-top: 16px;'>
                <loading :active.sync='isLoading' :is-full-page="false" loader='bars' color="#fe9616" :width='40' :height='40' />

                <table class="com-table">
                    <colgroup>
                        <col style="width: 80px" />
                        <col style="width: 150px" />
                        <col style="width: 150px" />
                        <col style="width: 120px" />
                        <col style="width: 140px" />
                        <col style="width: 120px" />
                        <col style="width: 140px" />
                        <col style="width: 180px" />
                        <col style="width: 140px" />
                        <col style="width: 140px" />
                        <col style="width: 120px" />
                    </colgroup>
                    <thead>
                    <tr>
                        <th>
                            <div class="com-check">
                                <input
                                    id="check-1-1"
                                    v-model="selectAll"
                                    name="check-1"
                                    type="checkbox"
                                    @change="allCheckBox"
                                />
                                <label for="check-1-1"></label>
                            </div>
                        </th>
                        <th>
                            <button @click="onClickCustomerNameColumn">회원명</button>
                        </th>
                        <th>닉네임</th>
                        <th>
                            <button @click="onClickCreDtColumn">등록일</button>
                        </th>
                        <th>연락처</th>
                        <th>생년월일</th>
                        <th>유효여부</th>
                        <th>사용중인 이용권</th>
                        <th>
                            <button @click="onClickTicketCountColumn">이용권등록수</button>
                        </th>
                        <th>
                            <button @click="onClickMileageColumn">마일리지</button>
                        </th>
                        <th>
                            <button @click="onClickLessonDtColumn">최근수업일</button>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(c, index) in customerList" :key="'A' + index">
                        <td>
                            <div class="com-check">
                                <input
                                    :id="`check-1-1-${c.center_cust_id}`"
                                    v-model="checkCustomerList"
                                    :value="c"
                                    name="check-1"
                                    type="checkbox"
                                />
                                <label :for="`check-1-1-${c.center_cust_id}`"></label>
                            </div>
                        </td>
                        <td>
                            <router-link
                                :to="{
                                    path: `/madmin/member/info/${c.center_id}`,
                                    query: { customerId: c.center_cust_id },
                                }"
                                class="link"
                            >
                                {{ c.namee }}
                            </router-link>
                        </td>
                        <td>{{ c.nick_name }}</td>
                        <td>{{ c.cre_dt | timestampFilter }}</td>
                        <td>{{ c.phone | customerPhoneFilter }}</td>
                        <td>{{ c.birthday | dateFormatFilter }}</td>
                        <td>{{ convertStatusCode(c.status_cd) }}</td>
                        <td>
                            <span
                                v-for="(t, index) in sortType(c.c_ticket_type_cd)"
                                :key="'B' + index"
                                :class="{
                                    ico: true,
                                    'type-1': t === 'P',
                                    'type-2': t === 'G',
                                    'type-4': t === 'T',
                                    'type-5': t === 'D',
                                    'type-6': t === 'O',
                                    'type-8': t === 'S',
                                }"
                            >
                                {{ convertTicketTypeFormat(t) }}
                            </span>
                            <span
                                v-for="(p, index) in c.c_prod_type_cd"
                                v-if="p === 'P'"
                                :key="'C' + index"
                                :class="{ ico: true, 'type-3': p === 'P' }"
                            >
                                {{ convertProdTypeFormat(p) }}
                            </span>
                            <!--                            <span class="ico type-1">[개인]</span>-->
                            <!--                            <span class="ico type-2">[그룹]</span>-->
                            <!--                            <span class="ico type-3">[패키지]</span>-->
                            <!--                            <span class="ico type-4">[회원권]</span>-->
                            <!--                            <span class="ico type-5">[듀엣]</span>-->
                            <!--                            <span class="ico type-6">[OT]</span>-->
                        </td>
                        <td>
                            {{
                                (parseInt(c.cp_ticket_type_cd_cnt) + parseInt(c.cp_prod_type_cd_cnt))
                                    | numberFormatFilter
                            }}
                        </td>
                        <td>{{ c.mileage | numberFormatFilter }}</td>
                        <td>{{ c.less_dt | timestampFilter }}</td>
                    </tr>
                    <tr v-if="customerList.length === 0">
                        <td colspan="100">{{ !isLoading ? '등록된 내용이 없습니다.' : '' }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="sort-bottom-area">
                <button
                    v-if="hasMessageEvent"
                    class="com-btn deep-blue left"
                    @click="routing('messageSend', checkCustomerList)"
                >
                    메시지 발송
                </button>
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
        </div>
        <b-pagination
            v-model="pagingInfo.page"
            :per-page="pagingInfo.limit"
            :total-rows="pagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event)"
        />
    </div>
</template>

<script>
import XLSX from 'xlsx';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import api from '@/assets/js/api';
import EventBus from '../../../assets/js/eventBus';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { customerPhoneForExcel, dateFormatFilter, numberFormat, timestampToDate } from '@/assets/js/excelCommon.js';
import { pagingInfo } from '@/assets/js/common';

export default {
    name: 'memberList',
    mixins: [MixinAllowedMenu],
    components: { Loading },
    props: {},
    watch: {
        // searchPeriod(newValue) {
        //     // 검색 기간 설정 변수
        //     this.searchPeriod = newValue;
        //     if (newValue === 'today') {
        //         // 오늘
        //         this.startDate = moment()
        //             .format('YYYY-MM-DD');
        //         this.endDate = moment()
        //             .format('YYYY-MM-DD');
        //     } else if (newValue === 'yesterday') {
        //         // 어제
        //         this.startDate = moment()
        //             .subtract(1, 'days')
        //             .format('YYYY-MM-DD');
        //         this.endDate = moment()
        //             .subtract(1, 'days')
        //             .format('YYYY-MM-DD');
        //     } else if (newValue === 'thisMonth') {
        //         // 이번 달
        //         this.startDate = moment()
        //             .startOf('month')
        //             .format('YYYY-MM-DD');
        //         this.endDate = moment()
        //             .endOf('month')
        //             .format('YYYY-MM-DD');
        //     } else if (newValue === 'prevMonth') {
        //         // 지난 달
        //         this.startDate = moment()
        //             .subtract(1, 'months')
        //             .startOf('month')
        //             .format('YYYY-MM-DD');
        //         this.endDate = moment()
        //             .subtract(1, 'months')
        //             .endOf('month')
        //             .format('YYYY-MM-DD');
        //     } else if (newValue === '3M') {
        //         // 3개월
        //         this.startDate = moment()
        //             .subtract(3, 'months')
        //             .format('YYYY-MM-DD');
        //         this.endDate = moment()
        //             .format('YYYY-MM-DD');
        //     } else if (newValue === '6M') {
        //         // 6개월
        //         this.startDate = moment()
        //             .subtract(6, 'months')
        //             .format('YYYY-MM-DD');
        //         this.endDate = moment()
        //             .format('YYYY-MM-DD');
        //     } else if (newValue === '12M') {
        //         // 12개월
        //         this.startDate = moment()
        //             .subtract(12, 'months')
        //             .format('YYYY-MM-DD');
        //         this.endDate = moment()
        //             .format('YYYY-MM-DD');
        //     } else if (newValue === '') {
        //         this.initStartDate();
        //         this.initEndDate();
        //     }
        //
        //     // 설정 바꾸면 첫 페이지로 세팅
        //     this.pagingInfo.page = 1;
        //     this.fetchCustomerList();
        // },
    },
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        centerChains() {
            const { getters } = this.$store;
            return getters['auth/centerChains'];
        },
    },
    mounted() {
        // 메시지보낼수 있는지 없는지 체크..
        this.checkMessageEvent();
        // 권한 체크
        this.goMainIfNotAllowed('MB', 1);
        this.centerId = this.cId; // 센터 Id
        this.centerChainList = this.centerChains; // 체인점 최고 관리자는 centerChains 에 본점 + 지점 목록이 있음
        this.init();
    },
    created() {
        this.settingForPreviousPage(localStorage.getItem('previousPath'));
    },
    data() {
        return {
            isLoading: false,
            centerId: '',
            centerChainList: [], // 본점 + 지점 체인점 목록

            // startDate: '',
            // endDate: '',
            customerList: [],
            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            pagingInfo: { ...pagingInfo },
            prevPagingStep: this.$route.query.prevPagingStep,
            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],

            memberGroupList: [],
            memberGroupValueList: [],

            searchStr: '', // 이름, 연락처 검색 파라미터
            searchPeriod: '', // 검색 기간 설정
            totalItems: '',
            searchSortType: 'DESC', // 정렬방법 (오름차순 : ASC, 내림차순 : DESC)
            sex: '',
            selectGroup: [],
            searchTeamIds: [],
            searchStatus: '', // 회원 상태 코드
            searchTicketTypes: [], // 이용권 구분 (P, O, D, G, C, T)
            searchSortColumn: '', // 정렬컬럼 (name, ticketCount, mileage, createAt)
            searchTicketStatus: '', // 이용권 유효여부
            inactiveDays: this.$route.query.inactiveDays,     // 미방문일수

            checkCustomerList: [], // 체크박스 선택한 회원 목록

            chainCenterType: [],
            chainCenterTypeValue: [],

            isLast: false, // 체크박스 전체 선택 및 해제 시에 필요한 설정값

            hasMessageEvent: false, // 권한에 따른 메세지 발송 버튼
            selectAll: false, // 전체 선택 해제
            count: 0,
            first: 2,
        };
    },
    methods: {
        fetchCustomerListPage1() {
            this.pagingInfo.page = 1;
            this.fetchCustomerList();
        },

        changeCenterId(val) {
            if (val) {
                this.centerId = val;
            } else {
                this.centerId = this.chainCenterTypeValue[0];
            }
            this.pagingInfo.page = 1;
            this.fetchCustomerList();
        },
        changeSex(val) {
            if (val) {
                this.sex = val;
            } else {
                this.sex = '';
            }
            this.pagingInfo.page = 1;
            this.fetchCustomerList();
        },
        changeSelectGroup(val) {
            this.selectGroup = val;
        },
        changeSearchTicketTypes(val) {
            this.searchTicketTypes = val;
            this.pagingInfo.page = 1;
            this.fetchCustomerList();
        },
        changeSearchTicketStatus(val) {
            this.searchTicketStatus = val;
            this.pagingInfo.page = 1;
            this.fetchCustomerList();
        },
        changeSearchTeamIds(val) {
            this.searchTeamIds = val;
            this.pagingInfo.page = 1;
            this.fetchCustomerList();
        },
        changeSearchStatus(val) {
            this.searchStatus = val;
            this.pagingInfo.page = 1;
            this.fetchCustomerList();
        },

        // 초기화
        init() {
            this.fetchMemberGroupList(); // 회원 그룹 가져오기
            this.fetchCustomerList(); // 회원 목록 가져오기
            this.fetchChainCenter(); // 소속 체인점 센터 조회
        },
        settingForPreviousPage(path) {
            // 이전페이지 페스 가지고 오기..
            const searchCondition = JSON.parse(localStorage.getItem('searchCondition'));
            // 이전 페이지에 페스에 문자열member가 포함되고, 수업관리에서 리스트호출에 필요한 변수 checkType가 없다면...
            if (path && path.includes('member/info') && !searchCondition.checkType) {
                this.pagingInfo.page = searchCondition.page;
                this.pagingInfo.limit = searchCondition.limit;
                this.pagingInfo.totalItems = searchCondition.totalItems;
                // this.startDate = searchCondition.startDate;
                // this.endDate = searchCondition.endDate;
                this.searchStr = searchCondition.searchStr;
                this.sex = searchCondition.sex;
                this.centerId = searchCondition.centerId;
                if (searchCondition.ticketTypes === '') {
                    this.searchTicketTypes = [];
                } else {
                    this.searchTicketTypes = searchCondition.ticketTypes.split(',');
                }
                this.searchTicketStatus = searchCondition.ticketStatus;
                this.inactiveDays = searchCondition.inactiveDays;
                if (searchCondition.centerCustomerTeamIds === '') {
                    this.searchTeamIds = [];
                } else {
                    this.searchTeamIds = searchCondition.centerCustomerTeamIds.split(',');
                    let temp = 0;
                    for (let i = 0; i < this.searchTeamIds.length; i++) {
                        temp = parseInt(this.searchTeamIds[i], 10);
                        this.searchTeamIds[i] = temp;
                    }
                }
                this.searchStatus = searchCondition.status;
                this.searchSortColumn = searchCondition.sortColumn;
                this.searchSortType = searchCondition.sortType;
            } else {
                // this.initStartDate(); // 검색 시작일 초기화
                // this.initEndDate(); // 검색 종료일 초기화
                this.pagingInfo.page = 1;
                this.pagingInfo.limit = 10;
            }
        },

        async changeCheckedUserGroup() {
            if (this.checkCustomerList.length === 0) {
                alert('선택된 회원이 없습니다.');
                return;
            }
            if (!this.selectGroup.length) {
                alert('선택된 그룹이 없습니다.');
            }
            if (!confirm('회원을 체크한 그룹으로만 재성정합니다. 진행하시겠습니까?')) return;

            const centerCustomerTeams = [];
            for (let i = 0; i < this.memberGroupList.length; i += 1) {
                if (this.selectGroup.includes(this.memberGroupValueList[i])) {
                    centerCustomerTeams.push({
                        centerCustomerTeamId: this.memberGroupValueList[i],
                        centerCustomerTeamName: this.memberGroupList[i],
                    });
                }
            }

            await api.put(`/admin/api/center/${this.centerId}/customer/group`, {
                centerCustomerTeams,
                userIds: this.checkCustomerList.map((v) => v.center_cust_id),
            });
            alert('그룹 설정이 완료되었습니다.');
        },

        // 엑셀 다운로드
        async excelDownload() {
            const { data } = await this.sendGetCustomerListForExcelDownload();

            const excelDownloadArray = [];
            data.items.forEach((member) => {
                const TICKET_TYPE_CD = this.sortType(member.c_ticket_type_cd);
                let tickets = '';
                for (const tickettypecdElement of TICKET_TYPE_CD) {
                    tickets += `${this.convertTicketTypeFormat(tickettypecdElement)} `;
                }
                let ticketTypeLength = 0;
                if (member.c_ticket_type_cd !== null) {
                    // 이용권
                    ticketTypeLength = member.c_ticket_type_cd.split(',').length;
                } else {
                    ticketTypeLength = 0;
                }

                const temp = {};
                temp['회원명'] = member.namee;
                temp['닉네임'] = member.nick_name;
                temp['연락처'] = customerPhoneForExcel(member.phone);
                temp['성별'] = member.sex === 'M' ? '남성' : '여성';
                temp['생년월일'] = dateFormatFilter(member.birthday);
                temp['출석번호'] = member.atnd_no;
                temp['이메일'] = member.email;
                temp['유효여부'] = this.convertStatusCode(member.status_cd);
                temp['사용중인 이용권'] = tickets;
                temp['이용권 등록수'] = parseInt(member.cp_ticket_type_cd_cnt) + parseInt(member.cp_prod_type_cd_cnt);
                temp['이메일동의'] = member.mkt_agree_email ? 'Y' : 'N';
                temp['SMS/MMS동의'] = member.mkt_agree_push ? 'Y' : 'N';
                temp['PUSH동의'] = member.mkt_agree_sms ? 'Y' : 'N';
                temp['앱연동'] = member.app_use_auth_yn ? 'Y' : 'N';
                temp['마일리지'] = numberFormat(member.mileage);
                temp['메모'] = member.memo;
                temp['등록일'] = timestampToDate(member.cre_dt);
                temp['센터명'] = member.c_center_nm;
                excelDownloadArray.push(temp);
            });
            const ws = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            const wscols = [
                { wch: 12 },
                { wch: 20 },
                { wch: 15 },
                { wch: 10 },
                { wch: 25 },
                { wch: 10 },
                { wch: 10 },
                { wch: 10 },
                { wch: 13 },
                { wch: 11 },
                { wch: 10 },
                { wch: 10 },
                { wch: 10 },
                { wch: 10 },
                { wch: 10 },
                { wch: 12 },
                { wch: 12 },
                { wch: 15 },
            ];
            ws['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            ws['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, '회원 목록');
            XLSX.writeFile(wb, '회원 목록.xlsx');
        },

        // 회원 목록 가져오기
        async fetchCustomerList() {
            this.isLoading = true;

            try {
                const { data } = await this.sendGetCustomerList();
                this.setPageParams(data);
                this.customerList = data.items;
                this.totalItems = data.meta.totalItems;
                if (this.customerList.length > 0) {
                    this.customerList.forEach((c) => {
                        // 사용중인 이용권('O, G')를 배열 형태로 변경
                        if (c.c_ticket_type_cd !== null) {
                            c.c_ticket_type_cd = c.c_ticket_type_cd.split(',');
                        }
                        if (c.c_prod_type_cd !== null) {
                            c.c_prod_type_cd = c.c_prod_type_cd.split(',');
                        }
                    });
                }

            } catch (error) {
                console.error(error);
            }

            this.isLoading = false;
        },

        // 센터회원 페이징 목록 조회
        sendGetCustomerList() {
            const {
                // startDate,
                // endDate,
                searchSortColumn,
                searchSortType,
                centerId,
                sex,
                searchTeamIds,
                searchStatus,
                searchStr,
                searchTicketTypes,
                searchTicketStatus,
                inactiveDays,
            } = this;
            const searchTeamIdsTemp = [];
            searchTeamIds.forEach((v, index) => {
                if (v !== 'all') {
                    searchTeamIdsTemp.push(v);
                }
            });
            const searchParams = {
                sortType: searchSortType, // 정렬방법 (오름차순 : ASC, 내림차순 : DESC)
                // startDate, // 검색시작일자
                // endDate, // 검색종료일자
                centerId,
                sex,
                // centerCustomerTeamIds: searchTeamIds.join(','),
                centerCustomerTeamIds: searchTeamIdsTemp.join(','),
                status: searchStatus, // 회원 상태 코드
                searchStr, // 이름/연락처 키워드 파라미터
                ticketTypes: searchTicketTypes.join(','), // 이용권 구분 (P, O, D, G, C, T)
                ticketStatus: searchTicketStatus,
                inactiveDays,
                sortColumn: searchSortColumn, // 정렬컬럼 (name, ticketCount, mileage, createAt)
                ...this.pagingInfo,
            };
            // if (!!searchParams.sex || !!searchParams.centerCustomerTeamIds || !!searchParams.status || !!searchParams.ticketTypes) {
            //     searchParams.endDate = '';
            //     searchParams.startDate = '';
            // }
            localStorage.setItem('searchCondition', JSON.stringify(searchParams));
            return api.get(`/admin/api/center/${this.centerId}/customer`, {
                params: {
                    ...this.pagingInfo,
                    ...searchParams,
                },
            });
        },

        // 센터회원 목록 조회 (엑셀 다운로드에만 씀)
        sendGetCustomerListForExcelDownload() {
            const {
                // startDate,
                // endDate,
                searchSortColumn,
                searchSortType,
                centerId,
                sex,
                searchTeamIds,
                searchStatus,
                searchStr,
                searchTicketTypes,
                searchTicketStatus,
                inactiveDays,
            } = this;
            const searchParams = {
                sortType: searchSortType, // 정렬방법 (오름차순 : ASC, 내림차순 : DESC)
                // startDate, // 검색시작일자
                // endDate, // 검색종료일자
                centerId,
                sex,
                centerCustomerTeamIds: searchTeamIds.join(','),
                status: searchStatus, // 회원 상태 코드
                searchStr, // 이름/연락처 키워드 파라미터
                ticketTypes: searchTicketTypes.join(','), // 이용권 구분 (P, O, D, G, C, T)
                ticketStatus: searchTicketStatus,
                inactiveDays,
                sortColumn: searchSortColumn, // 정렬컬럼 (name, ticketCount, mileage, createAt)
            };
            return api.get(`/admin/api/center/${this.centerId}/customer`, {
                params: {
                    page: 1,
                    limit: 10000,
                    ...searchParams,
                },
            });
        },

        // 소속 체인점 센터 조회
        async fetchChainCenter() {
            try {
                const { data } = await this.sendGetChainCenter();
                data.forEach((c) => {
                    this.chainCenterType.push(c.centerName);
                    this.chainCenterTypeValue.push(c.id);
                });
            } catch (error) {
                console.error(error);
            }
        },

        // 소속 체인점 센터 조회 API 호출
        sendGetChainCenter() {
            return api.get(`/admin/api/center/${this.cId}/chain`);
        },

        // 센터회원팀 목록 조회
        async fetchMemberGroupList() {
            try {
                const { data } = await this.sendGetMemberGroupList();
                data.forEach((g) => {
                    this.memberGroupList.push(g.c_center_cust_team_nm);
                    this.memberGroupValueList.push(g.c_center_cust_team_id);
                });
            } catch (error) {
                console.error('회원그룹을 가져오는 중 오류가 발생했습니다.');
                console.error(error);
            }
        },

        // 센터회원팀 API 호출
        sendGetMemberGroupList() {
            return api.get(`/admin/api/center/${this.centerId}/customer-team`);
        },

        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.fetchCustomerList();
        },

        // 페이징 이벤트
        async handlerPagenation(event) {
            this.pagingInfo.page = event;
            await this.fetchCustomerList();

            const checkList = this.checkSelectAll(this.checkCustomerList, this.customerList);
            if (checkList === this.pagingInfo.limit) {
                this.selectAll = true;
            } else {
                this.selectAll = false;
            }
        },

        checkSelectAll(checkList, customerList) {
            let answer = 0;

            for (let i = 0; i < checkList.length; i++) {
                for (let j = 0; j < customerList.length; j++) {
                    if (checkList[i].center_cust_id === customerList[j].center_cust_id) {
                        answer += 1;
                    }
                }
            }
            return answer;
        },

        // 검색 시작일 초기화
        // initStartDate() {
        //     const startDate = moment()
        //         .subtract(1, 'years')
        //         .format('YYYY-MM-DD');
        //     this.startDate = startDate;
        // },

        // 검색 종료일 초기화
        // initEndDate() {
        //     const endDate = moment()
        //         .format('YYYY-MM-DD');
        //     this.endDate = endDate;
        // },

        // 검색 시작일 변경 event
        // startDateUpdate(val) {
        //     if (this.count < this.first) {
        //         this.count += 1;
        //         return;
        //     }
        //     const check = moment(val)
        //         .isSameOrBefore(this.endDate, 'day');
        //
        //     if (check === false) {
        //         alert('조회 종료일보다 이후 날짜입니다. 다시 선택하세요.');
        //     } else {
        //         this.startDate = val;
        //         // 설정 바꾸면 첫 페이지로 세팅
        //         this.pagingInfo.page = 1;
        //         this.fetchCustomerList();
        //     }
        // },

        // 검색 종료일 변경 event
        // endDateUpdate(val) {
        //     if (this.count < this.first) {
        //         this.count += 1;
        //         return;
        //     }
        //     const check = moment(val)
        //         .isSameOrAfter(this.startDate, 'day');
        //
        //     if (check === false) {
        //         alert('조회 시작일보다 이전 날짜입니다. 다시 선택하세요.');
        //     } else {
        //         this.endDate = val;
        //         // 설정 바꾸면 첫 페이지로 세팅
        //         this.pagingInfo.page = 1;
        //         this.fetchCustomerList();
        //     }
        // },

        // 검색 조건 초기화
        resetSearchParams() {
            // this.initStartDate(); // 시작일 검색 파라미터
            // this.initEndDate(); // 종료일 검색 파라미터
            this.searchPeriod = '';
            this.searchSortType = '';
            this.searchSortColumn = '';
            this.inactiveDays = null;

            this.fetchCustomerList();
            EventBus.$emit('event:initList', 'init');
        },

        // 회원 목록 키워드 검색 이벤트
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }

            // 설정 바꾸면 첫 페이지로 세팅
            this.pagingInfo.page = 1;

            this.fetchCustomerList();
        },

        // 이용권 코드 변환
        convertTicketTypeFormat(type) {
            if (type === 'P') {
                return '[개인]';
            } else if (type === 'O') {
                return '[OT]';
            } else if (type === 'D') {
                return '[듀엣]';
            } else if (type === 'G') {
                return '[그룹]';
            } else if (type === 'C') {
                return '[쿠폰]';
            } else if (type === 'T') {
                return '[회원권]';
            } else if (type === 'S') {
                return '[운동복]';
            }
            return '';
        },

        // 상품 유형 코드 변환
        convertProdTypeFormat(type) {
            if (type === 'P') {
                return '[패키지]';
            }
        },

        // 유효여부 변환
        convertStatusCode(statusCd) {
            if (statusCd === 'V') {
                return '유효회원';
            } else if (statusCd === 'E') {
                return '만료회원';
            } else if (statusCd === '-') {
                return '잠재회원';
            } else if (statusCd === 'H') {
                return '홀딩회원';
            }
        },

        // 페이징 Param 설정
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },

        // 이용권 등록수 계산
        prodCount(index) {
            let ticketCount = 0;
            let packageCount = 0;

            if (this.customerList[index].c_ticket_type_cd !== null) {
                // 이용권 개수 구하기
                ticketCount = this.customerList[index].c_ticket_type_cd.length;
            }
            if (this.customerList[index].c_prod_type_cd !== null) {
                // 패키지 개수 구하기
                this.customerList[index].c_prod_type_cd.forEach((p) => {
                    if (p === 'P') {
                        packageCount++;
                    }
                });
            }
            return ticketCount + packageCount;
        },

        // 전체선택 체크박스 선택시
        allCheckBox() {
            const checkBoxArray = document.getElementsByName('check-1');
            const allCheckBox = document.getElementsByName('check-1')[0];
            const checkBoxLength = checkBoxArray.length;
            if (this.isLast) {
                this.isLast = false;
                return;
            }

            for (let i = 1; i < checkBoxLength; i++) {
                if (allCheckBox.checked === true && checkBoxArray[i].checked === false) {
                    checkBoxArray[i].click();
                } else if (allCheckBox.checked === false && checkBoxArray[i].checked === true) {
                    checkBoxArray[i].click();
                }
            }
        },

        // 복수 회원 삭제
        async deleteManyCustomers() {
            try {
                if (this.checkCustomerList.lenght === 0) {
                    alert('선택된 회원이 없습니다.');
                    return false;
                }
                if (!confirm('선택한 회원을 정말 삭제하시겠습니까?')) {
                    return false;
                }
                await this.sendDeleteManyCustomers();
                alert('회원이 삭제 되었습니다.');
                await this.init();
            } catch (error) {
                alert(error.response.data.message);
                console.error(error);
            }
        },

        // 복수 회원 삭제 API 호출
        sendDeleteManyCustomers() {
            let centerCustomerIds = '';
            for (const data of this.checkCustomerList) {
                centerCustomerIds += `${data.center_cust_id},`;
            }
            const ids = centerCustomerIds.substr(0, centerCustomerIds.length - 1);
            return api.delete(`/admin/api/center/${this.centerId}/customer/delete`, {
                params: {
                    centerCustomerIds: ids,
                },
            });
        },

        // 회원명 컬럼 클릭시
        onClickCustomerNameColumn() {
            this.searchSortColumn = 'name';
            if (this.searchSortType === '' || this.searchSortType === 'DESC') {
                this.searchSortType = 'ASC';
            } else {
                this.searchSortType = 'DESC';
            }
            this.fetchCustomerList();
        },

        // 이용권등록수 컬럼 클릭시
        onClickTicketCountColumn() {
            this.searchSortColumn = 'ticketCount';
            if (this.searchSortType === '' || this.searchSortType === 'DESC') {
                this.searchSortType = 'ASC';
            } else {
                this.searchSortType = 'DESC';
            }
            this.fetchCustomerList();
        },

        // 마일리지 컬럼 클릭시
        onClickMileageColumn() {
            this.searchSortColumn = 'mileage';
            if (this.searchSortType === '' || this.searchSortType === 'DESC') {
                this.searchSortType = 'ASC';
            } else {
                this.searchSortType = 'DESC';
            }
            this.fetchCustomerList();
        },

        // 등록일 컬럼 클릭시
        onClickCreDtColumn() {
            this.searchSortColumn = 'createAt';
            if (this.searchSortType === '' || this.searchSortType === 'DESC') {
                this.searchSortType = 'ASC';
            } else {
                this.searchSortType = 'DESC';
            }
            this.fetchCustomerList();
        },

        // 최근수업일 컬럼 클릭시
        onClickLessonDtColumn() {
            this.searchSortColumn = 'lessonAt';
            if (this.searchSortType === '' || this.searchSortType === 'DESC') {
                this.searchSortType = 'ASC';
            } else {
                this.searchSortType = 'DESC';
            }
            this.fetchCustomerList();
        },

        sortType(ticketType) {
            if (!ticketType) {
                return [];
            }

            const sorted = [];
            for (const t of ticketType) {
                if (!sorted.includes(t)) {
                    sorted.push(t);
                }
            }
            return sorted;
        },

        routing(toName, checkedUserData) {
            const routingData = [];
            checkedUserData.forEach((param) => {
                const tempValue = {
                    centerCustomerId: param.center_cust_id,
                    name: param.namee,
                    phone: param.phone,
                };
                routingData.push(tempValue);
            });
            this.$router.push({
                name: toName,
                params: { data: routingData },
            });
        },

        checkMessageEvent() {
            api.get('/admin/api/center/ftcontract/sms')
                .then((res) => {
                    this.hasMessageEvent = JSON.parse(res.data);
                })
                .catch((error) => {
                    this.hasMessageEvent = false;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.line label {
    font-size: 14px;
    line-height: 32px;
    color: #808080;
    margin-right: 24px;
}

.line .input-group {
    width: 150px;
}

.input-group input {
    text-align: right;
}

.line .btn {
    margin-left: 8px;
    min-width: 80px;
    font-size: 15px;
}
</style>
